// ============================================
// Manor Miser - Tile Catalog
// ============================================
// Named tile IDs for the 1bit_fantasy_pyairvander tileset.
// Tileset is 20 columns × 8 rows, 16×16 px tiles.
// Tiled uses 1-based IDs (firstgid=1).
// ID = row * 20 + col + 1

// Helper to compute tile ID from tileset grid position
function tid(row: number, col: number): number {
  return row * 20 + col + 1;
}

// ----------------------------------------
// Walls (row 0, 1, 2)
// ----------------------------------------
export const WALL_UPPER_LEFT  = tid(0, 0); // 1
export const WALL_UPPER       = tid(0, 1); // 2
export const WALL_UPPER_RIGHT = tid(0, 2); // 3
export const WALL_LEFT        = tid(1, 0); // 21
export const WALL_CENTER      = tid(1, 1); // 22
export const WALL_RIGHT       = tid(1, 2); // 23
export const WALL_LOWER_LEFT  = tid(2, 0); // 41
export const WALL_LOWER       = tid(2, 1); // 42
export const WALL_LOWER_RIGHT = tid(2, 2); // 43

// ----------------------------------------
// Paths (row 0-1, col 3-7)
// ----------------------------------------
export const PATH_NS       = tid(0, 3); // 4  — north↔south
export const PATH_SE       = tid(0, 4); // 5  — south→east turn
export const PATH_WSE      = tid(0, 5); // 6  — west/south/east T-junction
export const PATH_ALL      = tid(0, 6); // 7  — all directions crossroads
export const PATH_END_S    = tid(0, 7); // 8  — dead end from south

// Brick path variants (same shapes, different texture)
export const PATH_BRICK_NS   = tid(1, 3); // 24
export const PATH_BRICK_SE   = tid(1, 4); // 25
export const PATH_BRICK_WSE  = tid(1, 5); // 26
export const PATH_BRICK_ALL  = tid(1, 6); // 27
export const PATH_BRICK_END  = tid(1, 7); // 28

// ----------------------------------------
// Rocks (row 2, col 3-7)
// ----------------------------------------
export const ROCKS_1 = tid(2, 3); // 44
export const ROCKS_2 = tid(2, 4); // 45
export const ROCKS_3 = tid(2, 5); // 46
export const ROCKS_4 = tid(2, 6); // 47
export const ROCKS_5 = tid(2, 7); // 48

// ----------------------------------------
// Vegetation / Grass (rows 3-4, col 0-2)
// ----------------------------------------
export const GRASS_FEW      = tid(4, 0); // 61
export const GRASS_MEDIUM   = tid(4, 1); // 62
export const GRASS_FLOWER   = tid(4, 2); // 63
export const GRASS_FLOWERS2 = tid(5, 0); // 81
export const GRASS_HEAVY    = tid(5, 1); // 82
export const GRASS_TALL     = tid(5, 2); // 83

// ----------------------------------------
// Decorations / Furniture
// ----------------------------------------
export const CANDLE         = tid(4, 3); // 64
export const CAULDRON       = tid(4, 4); // 65
export const DOOR_CLOSED    = tid(4, 5); // 66
export const DOOR_OPEN      = tid(4, 6); // 67
export const DOOR_IRON      = tid(4, 7); // 68

export const BED            = tid(5, 3); // 84
export const BOOKSHELF      = tid(5, 4); // 85
export const SIGN_BLANK     = tid(5, 5); // 86
export const SIGN_STORE     = tid(5, 6); // 87
export const FENCE_WOOD     = tid(5, 7); // 88

export const SHRUB_1        = tid(6, 0); // 101
export const SHRUB_2        = tid(6, 1); // 102
export const TREE_LG_TOP    = tid(6, 2); // 103
export const SWITCH         = tid(6, 3); // 104
export const PODIUM         = tid(6, 4); // 105
export const CHEST          = tid(6, 5); // 106
export const CAMPFIRE       = tid(6, 6); // 107
export const FLAG           = tid(6, 7); // 108

export const DEADWOOD       = tid(7, 0); // 121
export const TREE_SMALL     = tid(7, 1); // 122
export const TREE_LG_BOTTOM = tid(7, 2); // 123
export const STAIRS_UP      = tid(7, 3); // 124
export const STAIRS_DOWN    = tid(7, 4); // 125
export const LADDER         = tid(7, 5); // 126
export const WINDOW         = tid(7, 6); // 127
export const LOGS           = tid(7, 7); // 128

// ----------------------------------------
// Tile classification
// ----------------------------------------

/** Tiles that block movement */
export const SOLID_TILES = new Set([
  WALL_UPPER_LEFT, WALL_UPPER, WALL_UPPER_RIGHT,
  WALL_LEFT, WALL_CENTER, WALL_RIGHT,
  WALL_LOWER_LEFT, WALL_LOWER, WALL_LOWER_RIGHT,
  BOOKSHELF, BED, CHEST, CAULDRON, FENCE_WOOD,
  TREE_LG_TOP, TREE_LG_BOTTOM, TREE_SMALL,
  SHRUB_1, SHRUB_2, DEADWOOD,
  ROCKS_1, ROCKS_2, ROCKS_3, ROCKS_4, ROCKS_5,
  PODIUM,
]);

/** Decoration tiles that can be scattered on the floor */
export const DECO_FLOOR = [
  GRASS_FEW, GRASS_MEDIUM, GRASS_FLOWER,
  GRASS_FLOWERS2, GRASS_HEAVY,
];

export const DECO_FURNITURE = [
  CANDLE, BOOKSHELF, CHEST, CAMPFIRE, FLAG, LOGS,
];

/** Empty floor (tile 0 = no tile) */
export const FLOOR = 0;
